import type React from "react";
import {formatInt} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Format.ts";

export type PtV2Bar = {
    key: string;
    label: React.ReactNode;
    /** Smaller text after the label. */
    sub?: React.ReactNode;
    value: number;
    color?: string;
    /** The value column; defaults to the number. */
    display?: React.ReactNode;
};

type Props = {
    rows: PtV2Bar[];
    /** Shared scale; defaults to the largest value so every bar reads against the same axis. */
    max?: number;
    color?: string;
};

/** Horizontal bars to one scale: label · track · value. */
export const PtV2Bars: React.FC<Props> = ({rows, max, color}) => {
    const scale = max ?? Math.max(1, ...rows.map(r => r.value));
    return <div className="ptv2-bars" role="list">
        {rows.map(r => <div className="ptv2-bar" role="listitem" key={r.key}>
            <div className="ptv2-bar-k" title={typeof r.label === 'string' ? r.label : undefined}>
                {r.label}{r.sub && <span>{r.sub}</span>}
            </div>
            <div className="ptv2-bar-track">
                <div className="ptv2-bar-fill" style={{
                    width: `${Math.min(100, Math.max(0, r.value / scale * 100))}%`,
                    background: r.color ?? color,
                }}/>
            </div>
            <div className="ptv2-bar-v ptv2-num">{r.display ?? formatInt(r.value)}</div>
        </div>)}
    </div>;
};
